import { AnnotationComponent } from '../../ui'

class StrongComponent extends AnnotationComponent {
  getTagName() {
    return 'strong'
  }
}

export default StrongComponent
